/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */
import ImageResize from "../ImageResize";
import {ImageResizeOptions} from "../imageresizeoptions";
import Quill from "quill";
/**
 * Aangepast aan TS en wat wijzigingen
 * Jelmer Jellema - Spin in het Web - 5-2024
 */
export class BaseModule {
  constructor(protected resizer: ImageResize, protected quill: Quill, protected options: ImageResizeOptions) {
  }
  onCreate(): void {}
  onDestroy(): void {}
  onUpdate(): void {}
}
